import * as React from "react";
import Button from "antd/lib/button";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import Tooltip from "antd/lib/tooltip";

import { useSelector, useDispatch } from "react-redux";
import { useCtx } from 'one-ui-provider';

const five9transfer = (agentid?: any, callid?: any, dn?: any) => {

  let interactionApi = window.Five9.CrmSdk.interactionApi();
  interactionApi.executeRestApi({ path: `/appsvcs/rs/svc/agents/${agentid}/interactions/calls/${callid}/transfer_to_external_number`, method: 'PUT', payload: `{"destination":{"checkMultipleContacts": ${false},"number":${dn} ,"skipDNCCheck": ${false}},"timeout": ${0},"warm": ${true}}` }).then(function (result: any) {
}, function (error: any) {
    // reject handler
    console.debug('Auth metadata error ', error);
});
}

const consult = (actions: any, target: any, usepv:any, updatepvornot:boolean,log:any, type: any, label: any, contact_center_type: any, agentId: any, callId: any, dispatch: any) => {
console.debug("----Consult")
}


/**
 * This function returns all the Hot buttons
 * @param props has all input parameters to load the Card
 * @returns JSX code for Hot Buttons
 */

export const HotButtonsFive9 = (props: any) => {
  const {  dnis, actions } = useSelector((state: any) => (
    state.hotkeys
  ));
  const choosecaller = useSelector((state: any) => (state.choosecaller));
  const five9Store = useSelector((state: any) => (state.five9callinfo));
  const dispatch = useDispatch();
 const  disabled = !((five9Store.callid))

  const { settings,log, agentId } = useCtx();
  const { hotkeys = {} } = settings;
  const {updatepv } = settings;
  const { compatible } = settings;
  const { contact_center_type } = compatible;
  const { map, dnisMap } = hotkeys;
  let updatepvornot = false;
  let pvarariable = updatepv?.usepv;
  if(pvarariable && pvarariable != "" ){
    updatepvornot = true;
  }
  const keys = ((dnisMap) && (dnisMap[dnis])) || map || [];
  let index = 0;
  const keyComps = [];
  while (index < keys.length) {
    const buttons = [];
    const maxCols = 2;
    for (let colIndex = 0; colIndex < maxCols; colIndex++) {
      if (index < keys.length) {
        let key = keys[index];
        buttons.push(
          <Col span={24 / maxCols} style={{ padding: '2px' }} >
            <Tooltip title={key.label}>
            <Button className="ant-btn--menu" style={{ fontSize: '1.0rem', whiteSpace: 'normal' }}  disabled={disabled}  size="large" block={true} onClick={
              (key.type === 'blind') ?
                (() => { five9transfer(five9Store.agentinfo, five9Store.callid, key.dn) }) :
                (() => { consult(actions, key.dn, pvarariable, updatepvornot,log, key.type, key.label, contact_center_type, agentId, choosecaller?.callId, dispatch) })
            }>{key.label}</Button>
            </Tooltip>
          </Col>
        );
        index = index + 1;
      }
    }
    keyComps.push(
      <>
       <ul key="1" className="ant-drawer__menu">
          <Row>
            {buttons}
          </Row>
        </ul>
      </>
    );
  }
  return (
   <>
      <div className="ant-drawer__subtitle">Hot Buttons</div>
      {keyComps}
   </>
  );
};
